module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_property-desc.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_property-desc.js
// module chunks = 168707334958949